import { render, staticRenderFns } from "./UserstList.vue?vue&type=template&id=2551ec61&"
import script from "./UserstList.vue?vue&type=script&lang=js&"
export * from "./UserstList.vue?vue&type=script&lang=js&"
import style0 from "./UserstList.vue?vue&type=style&index=0&id=2551ec61&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports